// @ts-nocheck
// this "fixes" the window errors

import TagManager from 'react-gtm-module';
import { v5 as uuidv5 } from 'uuid';

import { capitalize } from './utils';
import products from '../tracking-products';

const categoriesByProduct = {
  goboat: 'Boat Rental',
  sauna: 'Sauna Rental',
};

export const getCategory = (product: 'goboat' | 'sauna') => {
  return categoriesByProduct[product] || capitalize(product);
};

// Init GTM
export const setTagManager = (gtmId: string, lang: string) => {
  if (!gtmId) gtmId = 'GTM-5P5CM5F';

  TagManager.initialize({
    gtmId,
    dataLayer: {
      environment: process.env.REACT_APP_NODE_ENV,
      language: lang,
    },
  });
};

// Init FB Pixel
export const setPixel = (pixelId: string) => {
  if (!pixelId) return null;

  const initPixel = () => {
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  };

  if (window.fbq) return initPixel();

  const pixel = (window.fbq = function () {
    pixel.callMethod
      ? pixel.callMethod.apply(pixel, arguments)
      : pixel.queue.push(arguments);
  });

  if (!window._fbq) window._fbq = pixel;

  pixel.push = pixel;
  pixel.loaded = !0;
  pixel.version = '2.0';
  pixel.queue = [];

  const trackingScript = document.createElement('script');
  trackingScript.async = true;
  trackingScript.src = 'https://connect.facebook.net/en_US/fbevents.js';

  const body = document.getElementsByTagName('body')[0];
  body.appendChild(trackingScript);

  initPixel();
};

// Helper functions
// Tag Manager needs a string, Pixel needs a number
export const formatPriceTagManager = (price: number) => (price / 100).toFixed(2);
export const formatPricePixel = (price: number) => price / 100;

export const trackTagManagerEvent = (event: any) => {
  if (process.env.REACT_APP_ANALYTICS_ENABLED === 'true') {
    if (window.dataLayer) return window.dataLayer.push(event);
  } else {
    return console.log(event);
  }
};

export const trackPixelEvent = (type: any, object: any) => {
  if (process.env.REACT_APP_ANALYTICS_ENABLED === 'true') {
    if (window.fbq) {
      if (object) return window.fbq('track', type, object);

      return window.fbq('track', type);
    }
  } else {
    if (object) return console.log(type, object);

    return console.log(type);
  }
};

export const trackTikTokPixelEvent = (type: any, object?: any) => {
  if (process.env.REACT_APP_ANALYTICS_ENABLED === 'true') {
    if (window.ttq) {
      return window.ttq.track(type, object);
    }
  } else {
    return console.log('tiktok', type, object);
  }
};

// Default uuid v5 namespace
const UUID_NAMESPACE = uuidv5.URL;

interface GetProductProps {
  type: 'goboat' | 'sauna' | 'giftcard' | 'warranty';
  duration?: number;
}

export const getProduct = ({ type, duration }: GetProductProps = { type: 'goboat' }) => {
  // Don't break existing product id's
  if (products[type] && !duration) {
    return products[type];
  }
  if (products[type] && duration && products[type][duration]) {
    return products[type][duration];
  }

  const capType = type.charAt(0).toUpperCase() + type.slice(1);

  const name = duration ? `${duration}hour${capType}` : capType;
  const id = uuidv5(name, UUID_NAMESPACE);

  return { id, name };
};
